<div class="rounded-[20px] bg-white widget-card h-full !p-0">
    <div class="flex flex-col h-full">
        @if (loading()) {
            <ng-container *ngFor="let card of cards; let last = last">
                <div class="flex items-center gap-3 w-full flex-1 px-4 py-3"
                    [style.border-bottom]="last ? 'none' : '1px solid #E6E6E6'">
                    <p-skeleton shape="rectangle" width="45px" height="45px" borderRadius="12px"></p-skeleton>
                    <div class="flex flex-col gap-2 flex-1 min-w-0">
                        <p-skeleton width="60%" height="14px"></p-skeleton>
                        <p-skeleton width="40%" height="10px"></p-skeleton>
                    </div>
                    <p-skeleton width="2.5rem" height="1.75rem"></p-skeleton>
                </div>
            </ng-container>
        } @else {
            <ng-container *ngFor="let card of cards; let last = last">
                <button type="button"
                    class="flex items-center gap-3 w-full flex-1 px-4 text-left cursor-pointer bg-transparent border-0 hover:opacity-80 transition-opacity"
                    [style.border-bottom]="last ? 'none' : '1px solid #E6E6E6'"
                    (click)="openCard(card)">
                    <!-- Icon 45×45 -->
                    <div class="w-[45px] h-[45px] flex-shrink-0 rounded-xl overflow-hidden">
                        <img [src]="card.iconSrc" alt="" class="w-full h-full" />
                    </div>
                    <!-- Label + subtitle -->
                    <div class="flex flex-col gap-1 flex-1 min-w-0">
                        <div class="flex items-center gap-2">
                            <span class="text-[16px] font-semibold text-[#1c1c1c]"
                                style="font-feature-settings:'ss01' 1,'cv01' 1">{{ card.label }}</span>
                            <i class="pi pi-info-circle size-[16px] text-[#787B83]" [pTooltip]="card.description"
                                tooltipPosition="top"></i>
                        </div>
                        <span class="text-xs font-normal text-[#999]">{{ card.description }}</span>
                    </div>
                    <!-- Count + chevron -->
                    <div class="flex items-center gap-3 flex-shrink-0">
                        <span class="text-3xl font-bold text-gray-900 truncate min-w-0">{{ valueFor(card) }}</span>
                        <i class="pi pi-angle-right text-[18px] text-[#999999]"></i>
                    </div>
                </button>
            </ng-container>
        }
    </div>
</div>